export default __webpack_public_path__ + "static/media/sidebar-3.7df9aa1d.jpg";